import React, { useState, useEffect } from "react";

import { detectMob, isIOSDevice, isMobileSafari } from "utils/helpers";

import { Button, Modal } from "react-bootstrap";

import iosShareIcon from "assets/images/iosShareIcon.png";

import pwaIcon from "assets/images/pwa-icon.svg";
import logger from "helpers/logger";
import { Link } from "react-router-dom";

const ReactPWA = () => {
  const [state, setState] = useState({
    prompt: null,
    isShowPwaAndroidSetting: false,
    isShowPwaIOSSetting: false,
    isSupportPWA: true,
    isModalOpen: false,
  });

  const handleStateChange = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      ...(typeof key === "string" ? { [key]: value } : key),
    }));
  };

  useEffect(() => {
    if ("onbeforeinstallprompt" in window) {
      window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        handleStateChange("prompt", e);
      });

      window.addEventListener("appinstalled", () => {
        logger("INSTALL: Success");
      });
    } else {
      handleStateChange("isSupportPWA", false);
    }
  }, [prompt]);

  const handleOpenPwaSetting = (e) => {
    e?.preventDefault?.();
    if (state.prompt) {
      state?.prompt?.prompt?.();
      state?.prompt?.prompt?.userChoice?.then?.((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          logger("User accepted the install prompt");
        } else {
          logger("User dismissed the install prompt");
        }
      });
    } else {
      handleStateChange({
        [!isIOSDevice ? "isShowPwaAndroidSetting" : "isShowPwaIOSSetting"]:
          true,
        isModalOpen: true,
      });
    }
  };

  const renderButton = () => {
    if (detectMob()) {
      if ((detectMob() && !isIOSDevice) || (isIOSDevice && isMobileSafari)) {
        return (
          <div className="pwa-btn">
            <Link onClick={handleOpenPwaSetting}>
              <img src={pwaIcon} alt="pwa-icon" />
            </Link>
          </div>
        );
      }
    }
  };

  if (!detectMob()) {
    return <></>;
  }

  return (
    <>
      {renderButton()}
      {state.isModalOpen && (
        <Modal
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={state.isModalOpen}
          onBackdropClick={() => handleStateChange("isModalOpen", false)}
          onHide={() => handleStateChange("isModalOpen", false)}
        >
          {state.isShowPwaAndroidSetting ? (
            <div className="text-center">
              <div className="mt-20 p-lg-5 p-4">
                <h2 className="modal-title mb-3">Add Broker PWA shortcut</h2>
                <p className="mt-2 text-black">
                  <span className="inline-block">Click</span>
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 inline-block text-white fill-current"
                      viewBox="0 0 512 512"
                      width={18}
                    >
                      <title>Ellipsis Vertical</title>
                      <circle cx="256" cy="256" r="48" />
                      <circle cx="256" cy="416" r="48" />
                      <circle cx="256" cy="96" r="48" />
                    </svg>
                  </span>
                  <span>
                    then &apos;Add to Home screen&apos; from browser menu to add
                    Broker PWA shortcut for easy access
                  </span>
                </p>
                <Button
                  className="text-uppercase d-block h-auto mx-auto"
                  onClick={() => handleStateChange("isModalOpen", false)}
                >
                  Got It!
                </Button>
              </div>
            </div>
          ) : (
            <div className="absolute bottom-7 z-50 w-full bg-white">
              <div className="pwa-ios-setting flex items-start space-x-3 relative p-4 text-sm w-full shadow-md border-2 rounded-md d-flex">
                <div className="bg-gray-500 inline-block rounded-sm mt-1 iconPlus">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-6 fill-current text-white"
                    viewBox="0 0 512 512"
                    width={20}
                  >
                    <title>Add</title>
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="32"
                      d="M256 112v288M400 256H112"
                    />
                  </svg>
                </div>
                <p className="block mb-2">
                  <span className="inline-block">
                    <b>Install this webapp on your iPhone</b>: tap
                  </span>
                  &nbsp;
                  <img
                    className="w-2 inline-block"
                    src={iosShareIcon}
                    alt="share icon"
                    width={16}
                  />
                  &nbsp;
                  <span>and then Add to homescreen.</span>
                </p>
              </div>
            </div>
          )}
        </Modal>
      )}
    </>
  );
};

export default ReactPWA;
